import { Breadcrumb, Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import capitalize from '../../utils/capitalize';

const columns = [
  {
    title: 'Order Ref',
    dataIndex: 'order_ref',
    key: 'order_ref',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Session ID',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Receipt Number',
    dataIndex: 'receipt_number',
    key: 'receipt_number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Customer',
    dataIndex: 'customer',
    key: 'customer',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Employee',
    dataIndex: 'employee',
    key: 'employee',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Total',
    dataIndex: 'total_amount',
    key: 'total_amount',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Picking State',
    dataIndex: 'picking_state',
    key: 'picking_state',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/pos/sessions/'+record.order_ref.replaceAll('/', '-')}>
        EDIT
      </Link>
    )
  }
]

// const pos = [];

const PosOrders = () => {
  const posorders = useLoaderData();
  const navigate = useNavigate();
  const location = useLocation();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/pos/pos-orders/'+record.order_ref.replaceAll('/', '-'))
    };
  }
  const baseUrl = window.location.origin;

  let pathSegments = location.pathname.split('/').filter(Boolean).map((item, idx) => ({key: idx, path: item}));  return (
    <div>
      <div className='flex justify-between mx-4'>
        <Breadcrumb 
          items={pathSegments}
          itemRender={(currentRoute, params, routes, paths) => {
            const path = `/${routes.map(item => item.path).slice(0, currentRoute.key+ 1).join('/')}`; // Create the full path up to the current segment
            return (
              <Link to={`${baseUrl}${path}`}>{capitalize(currentRoute.path)}</Link>
            );
          }}
        />
          {/* <h3 className='font-bold'></h3> */}
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='flex justify-end mx-4 my-2'>
        
        <div className='flex justify-end'>
          <Pagination  total={50} />
      </div>
      </div>
      <Table
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={posorders}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'order_ref'}
      />
    
    </div>
  )
}

export default PosOrders;